import {useCallback, useEffect, useState} from 'react';
import {useCustomer} from "../../../layouts/SelfcareLayout";
import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {selfcarePaymentStatus, selfcarePayOverdueInvoices} from "../../../util/request";
import {staticNotificationMap} from "../../../util/staticNotificationMap";
import {BackButton} from "../../../components/selfcare/BackButton";
import LoaderSpinner from '../../../components/loaders/LoaderSpinner';
import Routing from "../../../Routing.ts";

export default function PayInvoicePage() {
    const {customer} = useCustomer()

    const shouldShowPayNowWidget = customer.customer_context.notifications.filter(n => {
        return [
            'invoice.pay-overdue-invoices',
            'invoice.is-processing-payment',
            'invoice.unpaid-invoice-and-credit-available',
        ].includes(n.type)
    }).length > 0

    return <SelfcarePageContent className='selfcare-page-pay-invoice'>
        <div className="selfcare-page-summary">
            <h1 className="heading heading--big">Betal udestående regning</h1>
        </div>
        <BackButton default_url={Routing.Selfcare.Bills}/>
        {shouldShowPayNowWidget ?
            <PayOverdueInvoices/>
        :
            <p>Du har ingen udestående regninger, som du mangler at betale.</p>
        }
    </SelfcarePageContent>
}

function PayNowWidget({onClick}: { onClick?: () => void }) {
    const {customer: {customer_context: {notifications}}} = useCustomer()

    const payNowNotification = notifications.filter(n => {
        return [
            'invoice.pay-overdue-invoices',
            'invoice.unpaid-invoice-and-credit-available',
        ].includes(n.type)
    })[0]

    if (!payNowNotification) return <></>

    return <>
        <p>{staticNotificationMap[payNowNotification.type].title(payNowNotification.payload)}</p>
        <button onClick={onClick} type={'button'} className={'button'}>
            Betal
        </button>
    </>
}

function PayOverdueInvoices() {
    const {customer: {customer_id}} = useCustomer()
    const [loading, setLoading] = useState<boolean>(false)

    const [isProcessingPayment, setIsProcessingPayment] = useState<boolean>(false)

    const pollPaymentStatus = useCallback(() => {
        selfcarePaymentStatus(customer_id)
            .then(res => {
                setIsProcessingPayment(res.response.data.is_pay_overdue_invoices_active)
                setLoading(false)
            })
    }, [customer_id]);

    useEffect(() => {
        pollPaymentStatus()
        const intervalCall = setInterval(pollPaymentStatus, 5000)

        return () => {
            clearInterval(intervalCall);
        };
    }, [pollPaymentStatus]);

    const onClick = () => {
        setLoading(true)
        selfcarePayOverdueInvoices(customer_id)
            .then(() => pollPaymentStatus())
    }

    if (loading) return <LoaderSpinner/>

    return <>
        {isProcessingPayment
            ? <p>{staticNotificationMap['invoice.is-processing-payment'].title({})}</p>
            : <PayNowWidget onClick={onClick}/>
        }
    </>
}
